module.exports = __webpack_public_path__ + "static/media/blog15.934741ff.svg";